<template>
  <div class="account-box">
    <div class="flex">
      <img class="avatar-img" v-if="this.$store.state.user.info.idPath" :src="this.$store.state.user.info.idPath" alt/>
      <img class="avatar-img" v-else src="../../assets/no-picture.png" alt/>
      <div class="account-info bg">
        <div class="title">我的账户</div>
        <div class="title-span">
          <span>会员名称：{{this.$store.state.user.info.name}}</span>
          <span>联系人：{{this.$store.state.user.info.linkman}}</span>
          <span>所属公司：{{this.$store.state.user.info.company}}</span>
          <span>联系电话：{{this.$store.state.user.info.telphone}}</span>
          <span v-if="this.$store.state.user.info.beforehandLimit > 0">授信额度：{{this.$store.state.user.info.beforehandLimit}}元</span>
          <span v-if="this.$store.state.user.info.beforehandLimit > 0">授信余额：{{this.$store.state.user.info.surplusLimit}}元</span>
          <span @click="$router.push('/user/manage')">查看更多>></span>
        </div>
      </div>
    </div>
    <div class="flex" style="margin-top: 20px">
      <div style="flex:2">
        <div class="bg">
          <p class="title">我的订单</p>
          <div class="order-btn-box">
            <div v-for="(item,i) in statusList" :key="i">
              <button class="common-btn-text" @click="goOrder('?orderStatus='+i)">{{item}}</button>
            </div>
            <div>
              <button class="common-btn-text" @click="goOrder('')">全部订单</button>
            </div>
          </div>
        </div>
        <div class="bg" style="margin-top: 20px">
          <p class="title">
            消费统计
            <el-select style="margin-left: 20px" size="small" v-model="timeStep" placeholder="请选择">
              <el-option label="本月" :value="1"></el-option>
              <el-option label="近3月" :value="3"></el-option>
              <el-option label="近半年" :value="6"></el-option>
            </el-select>
          </p>
          <div class="pie-chart"></div>
        </div>
      </div>
      <div style="margin-left: 20px;flex:1">
        <div class="bg">
          <p class="title">
            我的关注
            <span @click="$router.push('./myAttention')">更多></span>
          </p>
          <div class="browse-record">
            <div v-for="(item,i) in attentionList" :key="i">
              <img :src="item.commodity && item.commodity.defaultImage" alt />
            </div>
          </div>
        </div>
        <div class="bg" style="margin-top: 20px;">
          <p class="title">
            浏览记录
            <span @click="$router.push('./myBrowse')">更多></span>
          </p>
          <div class="browse-record">
            <div v-for="(item,i) in recordList" :key="i">
              <img :src="item.commodity && item.commodity.defaultImage" alt />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getAttentionList, getBrowseList } from "../../js/api";
export default {
  name: "UserHome",
  data() {
    return {
      timeStep: 1,
      statusList: [
        "提交订单",
        "待审核",
        "待确认",
        "待发货",
        "已发货",
        "已完成",
        "已关闭"
      ],
      recordList: [],
      attentionList: []
    };
  },
  methods: {
    goOrder(params) {
      this.$router.push("./order" + params);
    },
    drawPie() {
      const chart = this.$echarts.init(
        document.querySelector(".user-page .pie-chart")
      );
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        series: [
          {
            name: "消费统计",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["50%", "50%"],
            data: [
              { value: 335, name: "早教类" },
              { value: 310, name: "幼教类" },
              { value: 1548, name: "基础教育" }
            ],
            color: ["#AACD06", "#009944", "#FEE100"],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
      chart.setOption(option);
    },
    getBrowseList() {
      getBrowseList({
        pageNo: 1,
        pageSize: 4
      }).then(res => {
        if (res.code == 0) {
          this.recordList = res.result.records || [];
        }
      });
    },
    getAttentionList() {
      getAttentionList({
        pageNo: 1,
        pageSize: 4
      }).then(res => {
        if (res.code == 0) {
          this.attentionList = res.result.records || [];
        }
      });
    }
  },
  mounted() {
    this.drawPie();
    this.getAttentionList();
    this.getBrowseList();
  }
};
</script>

<style scoped>
.account-box .input >>> .el-input__inner {
  line-height: 48px;
  height: 48px;
  border-radius: 24px;
}
.account-box >>> .el-input {
  width: 300px;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
.account-box {
  flex: 1;
  margin: 20px;
  .avatar-img {
    // transform-origin: left center;
    // transform: scale(1.1);
    position: relative;
    z-index: 1;
    width: 180px;
    height: 180px;
    box-shadow: #aaa 0 0 15px;
  }
  .common-btn-text {
    color: rgb(131, 197, 136);font-weight: bold;
    &:hover{color: #333;}
  }
  .account-info {
    margin-top: 10px;
    height: 160px;
    flex: 1;
  }
  .account-info > div:last-child {
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    > span {
      margin-left: 40px;
      width: 25%;
      line-height: 32px;
      font-weight: bold;
    }
  }

  .order-btn-box {
    display: flex;
    align-items: flex-end;
    > div {
      line-height: 40px;
      flex: 1;
      text-align: center;
    }
  }

  .pie-chart {
    height: 240px;
  }

  .focus-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      padding: 12px 20px;
      line-height: 32px;
    }
  }
  .browse-record {
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      padding: 12px 20px;
      line-height: 32px;
      img {
        width: 100%;
      }
    }
  }
}

.title {
  padding-left: 20px;
  font-size: 15px;
  line-height: 40px;
  border-bottom: dashed 1px #ccc;
  span {
    float: right;
    margin-right: 20px;

    font-size: 12px;
    cursor: pointer;
  }
}
.title-span{
  overflow: hidden; white-space: nowrap; text-overflow: ellipsis;
}
.flex {
  display: flex;
}

</style>
